module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Bowie")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "template.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "title-no",
    attrs: {
      "id": "C1"
    }
  }, [_c('i', [_vm._v("One")])]), _vm._v(" "), _c('p', {
    staticClass: "title-head"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLLINGTON")]), _vm._v(","), _c('br'), _vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UNTINGTON, AND")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OWIE")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Bowie’s beginning is rooted in the earliest history of Maryland and Prince George’s County. In 1696, the Council of Maryland divided Prince George’s County into six hundreds: Mattapany, Petuxant, Collington, Mount Calvert, Piscattoway, and New Scotland. By modern geographic boundaries, Collington Hundred stretches toward Collington Road (Maryland Route 197), embracing portions along Route 450 toward the Belair Mansion, and encompassing much of modern Bowie.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Dotted with small tobacco plantations, Collington was also the location of a large one; Belair Plantation was built in the early 1740s by Gov. Samuel Ogle. By 1800, the Duckett family had built Fairview, which would become the home of the Bowie family in later years.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In 1870, after almost 20 years of planning—and after the Civil War—the railroad came to the area. The Baltimore & Potomac Railroad, planned by the Bowie family, was chartered and later absorbed by the Pennsylvania Railroad. The coming of the railroad to the area spurred developer Ben Plumb to plan a town with spacious homes, stores, and places of worship at the junction of the line to Washington, DC. The new village was called Huntington City. The town renamed itself Bowie in 1882 in honor of Oden Bowie’s influence in bringing the railroad to town. In 1911, the Bowie Normal School, today’s Bowie State University, opened. In 1914, the Southern Maryland Agricultural Society opened Bowie Race Track, and on April 18, 1916, the area was incorporated as the town of Bowie.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("For many years, this area was a rural farming community with Huntington/Bowie as its focal point. Then, in the late 1950s, a dramatic change occurred. Belair Farm/Belair Stud was sold. The purchaser was developer William J. Levitt, who began a suburban community called Belairat-Bowie several miles south of Huntington City/Bowie. That development was annexed to the town of Bowie in 1959, and the face and geography of Bowie changed forever.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Today, Bowie is a vibrant city of over 18 square miles, filled with residences both old and new and home to a diverse population of over 56,000 residents. Local amenities include a large regional shopping center, small locally owned businesses, museums, parks, a gymnasium, an accredited senior center, and a hockey rink. Many different faith communities and excellent schools also contribute to the Bowie community and quality of life.")]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-40",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("These are the proceedings of the Council of Maryland in 1696. In 1695, Prince George’s County was created from parts of Calvert and Charles Counties and named for the husband of Queen Anne, Prince George of Denmark. The following year, the Council of Maryland formally divided the new county into six hundreds. Collington was one of those hundreds.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Collington, like most of 17th- and 18th-century Maryland, was comprised of small plantations growing subsistence crops and cultivating tobacco as a cash crop. Any evidence of the plantations scattered across Collington Hundred has long disappeared. According to historical notes from the Prince George’s County Historical Society, the Confederate guerilla John Boyle was captured by Union captain Thomas Watkins at Collington in 1864. In 21st-century Bowie, with modern development and commercial activity, it is difficult to imagine these small, ephemeral structures, surrounded by fields that provided food and a livelihood. (Courtesy of the Prince George’s County Historical Society.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-60",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The oldest section of Fair Running (sometimes called the Maenner House) was built on land known as Isaac’s Discovery. The stone structure is one of only two surviving examples of early-18th-century domestic architecture in Prince George’s County and the only early example in Bowie. Begun by Joseph Peach in 1727, the house was enlarged in 1802 by his grandson. The Maenner family, upon purchasing the house in 1885, added another wing. Fair Running, owned today by the City of Bowie, serves as the clubhouse and restaurant for the Bowie Golf Course.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Fairview was for many years the home of the Duckett and Bowie families. Built around 1800 for Baruch Duckett, it is a blend of architectural styles, with a Georgian Palladian exterior and lovely Federal-period trim interior components. A modern housing development surrounds Fairview today. The developer has secured and interpreted a number of building foundations (including an early Thoroughbred barn) associated with the plantation. A family graveyard close by is testimony to the generations of Ducketts and Bowies who called Fairview home. Among others, Gov. Oden Bowie (1824–1896) is interred in the graveyard. (Courtesy of the Prince George’s County Historical Society.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F5.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This street map detail of Huntington City (Bowie Station) is from the "), _c('i', [_vm._v("Atlas of Fifteen Miles Around Washington, Including the County of Prince George")]), _vm._v(". The map, published in 1878, not only offers a view of the scheme of Huntington City’s street plan but also indicates the homes of several residents. At its founding, the new village was called Huntington City. Some historians think the city was named in honor of 19th-century railroad financier Collis P. Huntington. The railroad station itself, however, has always been known as Bowie Station. Today, streets in the Huntington section of Bowie still have this same grid pattern, with the same name and number system planned by Ben Plumb.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F6.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This map of Queen Anne District Number 7 is also from the "), _c('i', [_vm._v("Atlas of Fifteen Miles Around Washington, Including the County of Prince George")]), _vm._v(". It gives a clear view of the rural nature of the area surrounding Huntington City. A number of families owning farms in the surrounding area also owned houses in town. Note that by 1878, other well-known areas of the county—Glenn Dale and Springfield, for instance—had already been established.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Although the village surrounding the railroad depot was called Huntington City, the station has been, since its earliest days, Bowie Station, in honor of Oden Bowie. This photograph offers a look at the lovely Victorian elegance of early railroad stations. Wooden boardwalks across the tracks gave access to the southbound track for riders heading to Washington, DC, and points south. Bowie Tower was an interlocking tower, one of many that used a series of heavy handles and levers to activate switching on tracks, a critical and important part of rail safety. The rods (which were connected to the interlocking machine inside the tower) were contained in metal conduits, visible in the lower left of the photograph, alongside the track.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F8.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Popes Creek passenger train and crew members are pictured in 1906. The railroad was one of the largest employers in Huntington City. Pictured at left are local men who served on the Pope’s Creek Line passenger train. From left to right are “Pokey” Morris, who delivered mail from the train to the post office; Houston Morris, express clerk; Warren Houck, conductor; William Thirles, brakeman; Edward Lancaster, baggage master; John W. Ryon, mail clerk; Luke Seitz, fireman; and West Charters, engineer. The Seitz family operated a hotel and bakery. Both Edward Lancaster’s and John Ryon’s houses have been restored and remain in use today.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F9.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Bowie Station was originally owned by the Baltimore & Potomac (B&P) Railroad and was to be a stop on the line to Southern Maryland and Pope’s Creek. The B&P had rights to construct a 20-mile spur into Washington, DC, in addition to the Southern Maryland line. The Pennsylvania Railroad, denied permission by Congress to build its own line into Washington, DC, bought the B&P and constructed the spur. The picture here shows the wye created by the spur. The line to Washington, DC, opened in July 1872 and the Pope’s Creek line in January 1873. To the left is the Pope’s Creek track; to the right is the track into Washington, DC.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F10.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Twin Houses, built by the B&P, are undated. The homes were built to temporarily house railroad workers and supervisory personnel while in town on railroad business. They are likely the oldest standing buildings in this part of town today and are privately occupied.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F11.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Frank Luers House, built around 1895 on Tenth Street, stood on one of Ben Plumb’s original Huntington City lots plotted in 1870. Built in a classic late Victorian style, the Luers family home contained nine rooms and two stairways. As was typical with many buildings in Huntington City, the house faced the railroad. Today, the structure remains in use as a private residence.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F12.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("This bird’s-eye view of Bowie is from the early 1900s. In March 1874, an act was passed by the Maryland Legislature to incorporate the town of Huntington. The act set up a “body corporate” that was named “the Commissioners of Huntington,” with the first municipal election to be held in April. Voting took place at the post office. Eight years later, in May 1882, the incorporation act was amended to change the body corporate to “the Commissioners of Bowie,” honoring Gov. Oden Bowie and his role in bringing the railroad to the area. On April 18, 1916, Bowie once again reincorporated, this time as the town of Bowie, adopting a charter still in place 100 years later.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-50",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F13.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Gov. Oden Bowie was born at Fairview Plantation in 1826. He was tutored at home as a young child. After his mother’s death, he was enrolled in the Preparatory School of St. John’s College in Annapolis and completed his education at St. Mary’s Seminary in Baltimore. After seeing action in the Mexican War, he served in both the Maryland House of Delegates and State Senate. He was Maryland’s governor from 1869 to 1872. Bowie was, along with other members of his family, instrumental in bringing the railroad to Prince George’s County. An ardent supporter of Thoroughbred racing and breeding, he served as president of the Maryland Jockey Club. The Preakness Stakes, the second leg of the Triple Crown, came to Pimlico Race Track as a result of Bowie’s interest in the sport. (Courtesy of the Maryland State Archives–Maryland Commission on Artistic Property.)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('img', {
    staticClass: "img-70",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F14.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "para1"
  }, [_vm._v("The Fladung and Weeks families surround Martin Fladung (center left) and Estella Weeks (center right) at their wedding in 1915. The wedding party stands in front of the Straining House, an Italianate dwelling built around 1870. John Straining, the house’s original occupant, purchased a number of lots in Huntington City. The house, still in use as a private residence, was the site of the Bowie Telephone Exchange for a number of years. It is recognized by Prince George’s County as a historic structure.")])])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Martin and Vincent Fladung are pictured on a horse-drawn hearse. The Fladung family, among Huntington City’s earliest residents, had a number of business enterprises. In addition to operating a blacksmith shop, Martin and Vincent Fladung served as the city’s undertakers. In the 19th and early 20th century, mourners frequently paid their last respects in the family homes of the deceased. The Fladung family’s funeral parlor was often used by those who were not able to have viewings and wakes in their homes.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The streetscape in Huntington City has changed over the years. Pictured here in the early 1900s at the intersection of Chestnut Avenue and Eleventh Street are businesses frequented by residents. In the distance is the old bridge over the railroad tracks. The buildings housed a livery stable (on the left) and several stores and a barbershop (on the right).")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F17.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("From left to right, Calvert Lancaster, Valerie Lancaster, and Carlyle Lancaster are pictured around 1930. The Lancaster children epitomize Ben Plumb’s goal that Huntington City would be a place where “children will be reared away from city temptations.” They stand in front of Johnston’s Store, the Lloyd family home, and the village’s pool room. Members of the family continue to reside in Huntington City/Old Bowie today. Carlyle “Jiggs” Lancaster grew up (in Bowie) to become a veteran of World War II, city attorney, and state’s attorney for Prince George’s County.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F18.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Postmistress Nettie Fowler stands in the doorway of an early Bowie post office, possibly the first. Postal patrons frequently picked up their mail at the post office, since rural free delivery (RFD) was not commonplace until the early 20th century.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F19.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("As with many small towns and villages in the area, Huntington/Bowie’s first fire department was literally a bucket brigade. In 1928, citizens formed the Bowie Volunteer Fire Department, funded by events and contributions. The first firehouse was built in 1928 by Charles Fladung. In 1939, the building shown here was constructed with funds set aside for a town hall. The department had two Ford Model T chemical trucks. For a short time, the firehouse functioned as a town hall. The town suffered three serious fires early in its history. In April 1895, an accidentally overturned kerosene lamp in Seitz’s Hotel was thought to be the cause of a fire. A year later, a serious fire occurred in another hotel. The 1910 fire was catastrophic, destroying the entire business district and threatening a number of homes. The railroad signal tower and telegraph lines were destroyed, rendering the town incommunicado for several hours. A new, permanent firehouse was a welcome and necessary addition to the town.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img-40",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F20.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("As part of a close and family-oriented community, residents of Huntington City enjoyed many festivals, picnics, ball games, and social events together. At a 1940s Fireman’s Parade, local beauties ride a fire engine from Company 19. Today’s fire station in Huntington/Old Bowie remains essential to the community’s safety and is still classified by Prince George’s County as Company 19.")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "Image",
      "src": "images/C1-F21.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("After the tragic death of William Woodward Jr., William J. Levitt purchased the Belair Farm, soon to become a huge residential community, Belair-at-Bowie. After acquiring a strip of land along Routes 197 and 450 connecting his development to what was then Bowie, Levitt approached the city administration in hopes of annexing Belair-at-Bowie to the city. After long discussions and visits to other Levitt developments, the town commissioners signed annexation documents in February 1959. Pictured at the signing are, from left to right, Walter Stewart, town commissioner; Carlyle “Jiggs” Lancaster, attorney for the town of Bowie; Frank Brown, president of the town commissioners; Lawrence Maenner, town commissioner; and Rose Mary Abell, town clerk. The annexation of Belair-at-Bowie changed the face of Bowie forever.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b884d6d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 81
// module chunks = 0